export default __webpack_public_path__ + "static/media/0045.9c2681a5.png";